import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchSeedsDropdownData,
  fetchSeedsVaritiesName,
  fetchSeedsDropdown,
  fetchJdOpsProductData,
  fetchProductNames,
  getProductsDetails,
  updateJDOpsProduct,
  getSeedsCostApi,
  putSeedsCostApi,
  putTillageWorkApi,
  getTillageData,
  getRatesTypesApi,
  getPlantingData,
  putPlantingCostApi,
  getApplicationDataFromApi,
  putApplicationData,
  getHarvestData,
  putHarvestCostApi,
} from "../services/productcostseed.api";
import {
  GenericDropdownItem,
  PriceDropdownItem,
  VaritiesDropdownItem,
  QuantityUnitDropdownItem,
  SeedsCountDropdownItem,
  PerSeedCountDropdownItem,
  GetBagsPerBushelDropdownItem,
  GetPerBushelCostDropdownItem,
  ServiceGridDropDownItem,
} from "../types/productcostseeds";
import { toast } from "react-toastify";
type CalYear = {
  year: number;
};
type Activity = {
  activity: string;
};
interface SeedsDropdownState {
  calYear: CalYear[];
  activity: Activity[];
  cropType: [];
  varities: VaritiesDropdownItem[];
  gernericName: GenericDropdownItem[];
  price: PriceDropdownItem[];
  quantityUnit: QuantityUnitDropdownItem[];
  seedsCount: SeedsCountDropdownItem[];
  perSeedCost: PerSeedCountDropdownItem[];
  bagsPerBushel: GetBagsPerBushelDropdownItem[];
  perBushelCost: GetPerBushelCostDropdownItem[];
  gridData: ServiceGridDropDownItem[];
  responsebool: boolean;
  deleteresonse: boolean;
  loading: boolean;
  error: string | null;
  approveresponse: boolean;
  modifyresponse: boolean;
  recordData: any;
  jdOpsProducts: any[];
  productNames: any[];
  productsDetails: any[];
  seedsCostArray: any[];
  plantingPrices: any[];
  harvestPrices: any[];
  filteredSeedsArray: any[];
  tillageOperationsData: any[];
  rateTypesArray: any[];
  applicationData: any[];
}

const initialState: SeedsDropdownState = {
  calYear: [],
  activity: [],
  cropType: [],
  varities: [],
  gernericName: [],
  price: [],
  quantityUnit: [],
  seedsCount: [],
  perSeedCost: [],
  bagsPerBushel: [],
  perBushelCost: [],
  gridData: [],
  loading: false,
  error: null,
  responsebool: false,
  deleteresonse: false,
  approveresponse: false,
  modifyresponse: false,
  recordData: [],
  jdOpsProducts: [],
  productNames: [],
  productsDetails: [],
  seedsCostArray: [],
  plantingPrices: [],
  harvestPrices: [],
  filteredSeedsArray: [],
  tillageOperationsData: [],
  rateTypesArray: [],
  applicationData: [],
};

export const fetchDropdown = createAsyncThunk(
  "seedsdropdown/fetch",
  async (dropdownType: string) => {
    const response = await fetchSeedsDropdownData(dropdownType);
    return response.data;
  }
);

export const fetchProductDropdown = createAsyncThunk(
  "seedsproductdropdown/fetch",
  async ({ value, calyear }: { value: string; calyear: number }) => {
    const response = await fetchSeedsVaritiesName(value, calyear);
    return response.data;
  }
);

export const fetchProductSeedsDropdown = createAsyncThunk(
  "productseedsdropdown/fetch",
  async ({ type, value }: { type: string; value: number }) => {
    const response = await fetchSeedsDropdown(type, value);
    return response.data;
  }
);

export const postJDOpsProduct = createAsyncThunk(
  "updateJdOps",
  async (type: any) => {
    const response = await updateJDOpsProduct(type);
    return response.data;
  }
);

export const getSeedsCostApiData = createAsyncThunk(
  "getSeedsCost",
  async (param?: number) => {
    let response;
    if (param) {
      response = await getSeedsCostApi(param);
    } else {
      response = await getSeedsCostApi();
    }
    // const response = await getSeedsCostApi();
    return response.data;
  }
);

export const getPlantingPriceData = createAsyncThunk(
  "getPlantingPriceData",
  async () => {
    const response = await getPlantingData();
    return response.data;
  }
);

export const savePlantingCostData = createAsyncThunk(
  "putPlatingCost",
  async (data: any) => {
    const response = await putPlantingCostApi(data);
    return response.data;
  }
);

export const getHarvestPriceData = createAsyncThunk(
  "getHarvestPriceData",
  async () => {
    const response = await getHarvestData();
    return response.data;
  }
);

export const saveHarvestCostData = createAsyncThunk(
  "putHarvestCost",
  async (data: any) => {
    const response = await putHarvestCostApi(data);
    return response.data;
  }
);

export const getTillageApiData = createAsyncThunk(
  "getTillageData",
  async () => {
    const response = await getTillageData();
    return response.data;
  }
);

export const getApplicationData = createAsyncThunk(
  "getApplicationData",
  async () => {
    const response = await getApplicationDataFromApi();
    return response.data;
  }
);

export const getRateTypes = createAsyncThunk("getRateType", async () => {
  const response = await getRatesTypesApi();
  return response.data;
});

export const putTillageWorkData = createAsyncThunk(
  "putTillageWork",
  async (data: any) => {
    const response = await putTillageWorkApi(data);
    return response.data;
  }
);

export const saveApplicationGridData = createAsyncThunk(
  "putApplicationAPi",
  async (data: any) => {
    const response = await putApplicationData(data);
    return response.data;
  }
);

export const saveSeedsCostData = createAsyncThunk(
  "putSeedsCost",
  async (data: any) => {
    const response = await putSeedsCostApi(data);
    return response.data;
  }
);

export const getJDOpsData = createAsyncThunk(
  "getJDOpsData",
  async (value: any) => {
    const response = await fetchJdOpsProductData(value);
    return response.data;
  }
);

export const updateJDOpsProductMapping = createAsyncThunk(
  "updateJDOpsProductMapping",
  async (value: any) => {
    const response = await updateJDOpsProduct(value);
    return response.data;
  }
);

export const fetchProductsDropDown = createAsyncThunk(
  "getProducts",
  async (value: any) => {
    const response = await fetchProductNames(value);
    return response.data;
  }
);

export const getProductDetails = createAsyncThunk(
  "getProductApi",
  async (value: any) => {
    const response = await getProductsDetails(value);
    return response.data;
  }
);

const seedsdropdownSlice = createSlice({
  name: "seedsdropdown",
  initialState,
  reducers: {
    resetResponseBool: (state) => {
      state.responsebool = false;
    },
    resetapproveresponse: (state) => {
      state.approveresponse = false;
    },
    resetmodifyresponse: (state) => {
      state.approveresponse = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDropdown.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDropdown.fulfilled, (state, action) => {
        state.loading = false;
        if (action.meta.arg === "calYear") {
          state.calYear = action.payload;
        } else if (action.meta.arg === "activity") {
          state.activity = action.payload;
        } else if (action.meta.arg === "cropType") {
          state.cropType = action.payload;
        }
      })
      .addCase(fetchDropdown.rejected, (state) => {
        state.loading = false;
        state.error = "Failed to fetch dropdown data.";
      })
      .addCase(fetchProductDropdown.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProductDropdown.fulfilled, (state, action) => {
        state.loading = false;
        state.varities = action.payload;
      })
      .addCase(fetchProductDropdown.rejected, (state) => {
        state.loading = false;
        state.error = "Failed to fetch dropdown data.";
      })
      .addCase(fetchProductSeedsDropdown.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getJDOpsData.fulfilled, (state, action) => {
        state.loading = false;
        state.jdOpsProducts = action.payload;
      })
      .addCase(getRateTypes.fulfilled, (state, action) => {
        state.loading = false;
        state.rateTypesArray = action.payload;
      })
      .addCase(getTillageApiData.fulfilled, (state, action) => {
        state.loading = false;
        const payload = action.payload;
        state.tillageOperationsData = payload.length
          ? payload.map((item: any) => ({
              ...item,
              formattedPeriods: item.periods
                .map(
                  (period: any) =>
                    `$${period.costPerAcre} (${period.firstTilled} - ${period.lastTilled})`
                )
                .join(", "),
            }))
          : payload;
      })
      .addCase(getApplicationData.fulfilled, (state, action) => {
        state.loading = false;
        const payload = action.payload;
        state.applicationData = payload.length
          ? payload.map((item: any) => ({
              ...item,
              formattedPeriods: item.periods
                .map(
                  (period: any) =>
                    `$${period.costPerAcre} (${period.firstApplied} - ${period.lastApplied})`
                )
                .join(", "),
            }))
          : payload;
      })
      .addCase(getSeedsCostApiData.fulfilled, (state, action) => {
        state.loading = false;
        const payload = action.payload;
        state.seedsCostArray = payload.length
          ? payload.map((item: any) => ({
              ...item,
              formattedPeriods: item.periods
                .map(
                  (period: any) =>
                    `$${period.discountedPrice} (${period.firstSeeded} - ${period.lastSeeded})`
                )
                .join(", "),
            }))
          : payload;
      })
      .addCase(getPlantingPriceData.fulfilled, (state, action) => {
        state.loading = false;
        const payload = action.payload;
        state.plantingPrices = payload.length
          ? payload.map((item: any) => ({
              ...item,
              formattedPeriods: formattedPrice(item.periods, {
                price: "costPerAcre",
                firstDate: "firstPlanted",
                lastDate: "lastPlanted",
              }),
            }))
          : payload;
      })
      .addCase(savePlantingCostData.fulfilled, () => {
        toast.success("Planting Cost saved successfully!");
      })
      .addCase(savePlantingCostData.rejected, (_state, error) => {
        toast.error(
          error.error.message || "Something went wrong. Please try again."
        );
      })
      .addCase(getHarvestPriceData.fulfilled, (state, action) => {
        state.loading = false;
        const payload = action.payload;

        state.harvestPrices = payload.length
          ? formatHarvestPricingData(payload)
          : payload;
      })
      .addCase(saveHarvestCostData.fulfilled, () => {
        toast.success("Harvest Cost saved successfully!");
      })
      .addCase(saveHarvestCostData.rejected, (_state, error) => {
        toast.error(
          error.error.message || "Something went wrong. Please try again."
        );
      })
      .addCase(saveSeedsCostData.fulfilled, () => {
        toast.success("Seeds Cost saved successfully!");
      })
      .addCase(putTillageWorkData.fulfilled, () => {
        toast.success("Tillage work saved successfully!");
      })
      .addCase(putTillageWorkData.rejected, (_state, error) => {
        toast.error(
          error.error.message || "Failed to save tillage work. Please try again."
        );
      })
      .addCase(saveApplicationGridData.fulfilled, () => {
        toast.success("Application product saved successfully!");
      })
      .addCase(saveApplicationGridData.rejected, (_state, error) => {
        toast.error(
          error.error.message || "Failed to save application product. Please try again."
        );
      })
      .addCase(updateJDOpsProductMapping.fulfilled, () => {
        toast.success("Product mapped successfully");
      })
      .addCase(updateJDOpsProductMapping.rejected, () => {
        toast.error("Failed to map the product. Please try again.");
      })
      .addCase(saveSeedsCostData.rejected, (_state, error) => {
        toast.error(
          error.error.message || "Failed to save seeds cost. Please try again."
        );
      })
      .addCase(fetchProductsDropDown.fulfilled, (state, action) => {
        state.loading = false;
        state.productNames = action.payload;
      })
      .addCase(getProductDetails.fulfilled, (state, action) => {
        state.loading = false;
        const payload = action.payload;

        state.productsDetails = payload.length
          ? payload.map((item: any) => ({
              ...item,
              formattedPeriods: item.periods
                .map(
                  (period: any) =>
                    `$${period.price} (${period.firstAppliedDate} - ${period.lastAppliedDate})`
                )
                .join(", "),
              linkedJdOpsProducts: item.linkedJdOpsProducts?.length
                ? item.linkedJdOpsProducts.join(", ")
                : item.linkedJdOpsProduct,
            }))
          : payload;
      });
  },
});

const formatHarvestPricingData = (data: any[]) => {
  return data.map((item: any) => {
    const harvestPrices = formattedPrice(item.periods, {
      price: "harvestPrice",
      firstDate: "firstHarvested",
      lastDate: "lastHarvested",
    });

    const haulingPrices = formattedPrice(item.periods, {
      price: "haulingPrice",
      firstDate: "firstHarvested",
      lastDate: "lastHarvested",
    });

    const haulingOveragePrices = formattedPrice(item.periods, {
      price: "haulingOveragePrice",
      firstDate: "firstHarvested",
      lastDate: "lastHarvested",
    });

    return { ...item, harvestPrices, haulingPrices, haulingOveragePrices };
  });
};

const formattedPrice = (data: any, keysObj: { [key: string]: string }) =>
  data
    .map((period: any) =>
      period[keysObj.price]
        ? `$${period[keysObj.price]} (${period[keysObj.firstDate]} - ${period[keysObj.lastDate]})`
        : ""
    )
    .filter((item: any) => item)
    .join(", ");


export default seedsdropdownSlice.reducer;
export const { resetResponseBool,resetmodifyresponse,resetapproveresponse } = seedsdropdownSlice.actions;